export default "__VITE_ASSET__CD4TQTd7__"